import { FC } from 'react'

import s from './ItemCount.module.css'

type Props = {
  countsByStage: {
    newInProgress: number
    approvalPending: number
    approved: number
    docCount: number
  }
  totalCount: number
}

export const ItemCount: FC<Props> = ({
  countsByStage: { newInProgress, approvalPending, approved, docCount },
  totalCount,
}) => {
  return (
    <>
      <svg viewBox="0 0 36 36" className={s.svg}>
        <path strokeDasharray={`${(newInProgress * 100) / totalCount}, 100`} />
      </svg>
      <svg viewBox="0 0 36 36" className={s.svg}>
        <path
          strokeDasharray={`${(approvalPending * 100) / totalCount}, 100`}
        />
      </svg>
      <svg viewBox="0 0 36 36" className={s.svg}>
        <path strokeDasharray={`${(approved * 100) / totalCount}, 100`} />
      </svg>
      <svg viewBox="0 0 36 36" className={s.svg}>
        <path strokeDasharray={`${(docCount * 100) / totalCount}, 100`} />
      </svg>
    </>
  )
}
